var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiscPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4444 5.55556V44.4444H5.55556V5.55556H44.4444ZM44.4444 0H5.55556C2.5 0 0 2.5 0 5.55556V44.4444C0 47.5 2.5 50 5.55556 50H44.4444C47.5 50 50 47.5 50 44.4444V5.55556C50 2.5 47.5 0 44.4444 0ZM30.9444 24.6111L22.6111 35.3611L16.6667 28.1667L8.33333 38.8889H41.6667L30.9444 24.6111Z",
    fill: "#0059B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscPrimary);
export default __webpack_public_path__ + "static/media/misc_primary.916c8e433f7b9143190750823677bd70.svg";
export { ForwardRef as ReactComponent };